import { useRef, useState, useEffect } from "react";
import Player from "@vimeo/player";
import ReCAPTCHA from "react-google-recaptcha";
import Swal from "sweetalert2";

import Header from "../header";
import { Link } from "react-router-dom";
import styles from "../home/index.module.css";
import { CheckImage, logo, LogoImage, VectorImage } from "../imagepath";
import AuthServices from "../../services/AuthServices";
const GetCertified = () => {
  useEffect(() => {
    if (iframeRef1.current) {
      playerRef1.current = new Player(iframeRef1.current);
    }
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const iframeRef1 = useRef(null);
  const playerRef1 = useRef(null);

  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [isSecondPlaying, setIsSecondPlaying] = useState(true);

  const handlePlay1 = () => {
    playerRef1.current?.play();
    setIsSecondPlaying(false);
  };

  const handlePause1 = () => {
    playerRef1.current?.pause();
    setIsSecondPlaying(true);
  };

  const handleCaptchaChange = (value) => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSendMessage = async (e) => {
    e.preventDefault();

    try {
      const response = await AuthServices.sendEmail(formData);
      console.log("response", response);
      Swal.fire({
        title: "Success!",
        text: "Sucessfully Sent!",
        icon: "success",
        confirmButtonText: "OK",
      });
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      Swal.fire({
        text: "Failed to Send!",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  const iframeRef2 = useRef(null);
  const playerRef2 = useRef(null);

  const [isThirdPlaying, setIsThirdPlaying] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (iframeRef2.current) {
      playerRef2.current = new Player(iframeRef2.current);
    }
  }, []);

  const handlePlay2 = () => {
    playerRef2.current?.play();
    setIsThirdPlaying(false);
  };

  const handlePause2 = () => {
    playerRef2.current?.pause();
    setIsThirdPlaying(true);
  };

  return (
    <div className="main-wrapper">
      <Header />
      <section
        className={`d-flex align-items-center ${styles.pricingContent}`}
        style={{ justifyContent: "space-around", padding: "100px 20px" }}
      >
        <div
          style={{
            justifySelf: "center",
            width: "100%",
            textAlign: "center",
          }}
        >
          <h1
            className={`${styles.pricingText} m-auto mb-5`}
            style={{ maxWidth: "1000px" }}
            title="School Emergency Certification"
          >
            Get Your School or Center Certified for Emergency Preparedness Today
          </h1>
          <div>
            Emergency readiness is no longer optional. Schools and child care
            centers that fail inspections or are unprepared for emergencies face
            lawsuits, fines, and tragic consequences. AngelWatch Certification
            prepares your entire staff to respond immediately, protects lives,
            ensures full compliance, and gives you peace of mind — starting
            today.
          </div>
          <div className={`d-flex flex-row justify-content-center`}>
            <div
              className={styles.whatDifferentLeft}
              style={{
                width: "600px",
                marginTop: "auto",
                marginBottom: "auto",
              }}
            >
              <section
                className={`d-flex flex-column align-items-center`}
                style={{
                  width: "100%",
                  borderRadius: "16px",
                }}
              >
                <iframe
                  ref={iframeRef1}
                  src="https://player.vimeo.com/video/1078781366?controls=0&title=0&byline=0&portrait=0"
                  allow="autoplay; picture-in-picture"
                  style={{ width: "100%", height: "360px", padding: "12px" }}
                ></iframe>
                <div
                  className={`d-flex gap-2 mt-3 justify-content-center ${styles.youtube__button}`}
                  style={{ alignSelf: "center" }}
                >
                  {isSecondPlaying ? (
                    <button
                      onClick={handlePlay1}
                      className={`btn btn-primary ${styles.youtube__button__width}`}
                    >
                      <img
                        src={require("../../assets/img/playIcon.png")}
                        style={{ width: "50%" }}
                      ></img>
                    </button>
                  ) : (
                    <button
                      onClick={handlePause1}
                      className={`btn btn-primary ${styles.youtube__button__width}`}
                    >
                      <img
                        src={require("../../assets/img/pauseIcon.png")}
                        style={{ width: "50%" }}
                      ></img>
                    </button>
                  )}
                </div>
              </section>
            </div>
          </div>

          <h2 className="mb-5">What’s Included in Your Certification Package</h2>

          <div className="w-75 m-auto" >
            <div className={styles.whatDifferentCard}>
              <div className={styles.whatDifferentCardMain}>
                <img
                  className={styles.whatDifferentCardMainImage}
                  src={CheckImage}
                />
                <div className="d-flex flex-column">
                  <span className={styles.whatDifferentCardTitle}>
                    Full Online Emergency Preparedness Training
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.whatDifferentCard}>
              <div className={styles.whatDifferentCardMain}>
                <img
                  className={styles.whatDifferentCardMainImage}
                  src={CheckImage}
                />
                <div className="d-flex flex-column">
                  <span className={styles.whatDifferentCardTitle}>
                    Active Shooter, Lockdown, Fire, and Medical Emergency Protocols
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.whatDifferentCard}>
              <div className={styles.whatDifferentCardMain}>
                <img
                  className={styles.whatDifferentCardMainImage}
                  src={CheckImage}
                />
                <div className="d-flex flex-column">
                  <span className={styles.whatDifferentCardTitle}>
                    Emergency Plan Templates to Meet State Licensing Requirements
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.whatDifferentCard}>
              <div className={styles.whatDifferentCardMain}>
                <img
                  className={styles.whatDifferentCardMainImage}
                  src={CheckImage}
                />
                <div className="d-flex flex-column">
                  <span className={styles.whatDifferentCardTitle}>
                    Staff Tracking Compliance Dashboard
                  </span>
                </div>
              </div>
            </div>
            <div className={styles.whatDifferentCard}>
              <div className={styles.whatDifferentCardMain}>
                <img
                  className={styles.whatDifferentCardMainImage}
                  src={CheckImage}
                />
                <div className="d-flex flex-column">
                  <span className={styles.whatDifferentCardTitle}>
                    Official AngelWatch Certificates for All Staff
                  </span>
                </div>
              </div>
            </div>
          </div>

          <p className={`${styles.warning} m-auto mt-5 mb-5`}>Every day without certification leaves your students, staff, and organization exposed to lawsuits, fines, and irreversible tragedies. Protect your community — and your reputation — with AngelWatch today.</p>
          <h2 className="m-auto text-center mt-5">Pricing and Enrollment Options</h2>
          <div
            className={`d-block d-xl-flex flex-row pt-5 gap-5 justify-content-center w-75 m-auto ${styles.displayBlock} ${styles.pricing__mobile}`}
          >
            <div className="d-block d-lg-flex justify-content-between gap-2 w-100">
              <div className="w-100 w-lg-50" style={{ justifyItems: "center" }}>
                <p
                  className={styles.priceDes}
                  style={{ minHeight: "150px", maxWidth: "400px" }}
                >
                  Best for licensed schools, preschools, and daycare centers.
                  Gives directors full access to training, compliance
                  documentation, recertification management, and emergency
                  protocol rewriting for every staff member.
                </p>
                <div
                  className={styles.pricingCard}
                  style={{ minHeight: "700px" }}
                >
                  <img
                    src={require("../../assets/img/discount2.jpg")}
                    className={styles.pricingDiscount}
                  ></img>
                  <span>For Individual Teachers & Caregivers</span>
                  <div className={styles.pricingPrice}>
                    <p className={styles.pricingNum}>$159.00</p>
                    <del className={styles.pricingOriginal}>Was $199</del>
                  </div>
                  <div className={styles.pricingList}>
                    <p className={styles.priceDes}>What’s included:</p>
                    <div className={styles.pricingCardText}>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>Unlimited access for your entire team</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Emergency Management System with tracking dashboard
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Staff certification and automatic recertification
                          alerts
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>Compliance documents, SOPs, and protocol handbook</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <p>Free plan rewrite to pass licensing inspections</p>
                      </div>
                    </div>
                    <Link to="/selectregister" className={styles.priceButton}>
                      <button className={styles.pricingBtn}>Sign Up</button>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="w-100 w-lg-50" style={{ justifyItems: "center" }}>
                <p
                  className={styles.priceDes}
                  style={{ minHeight: "150px", maxWidth: "400px" }}
                >
                  Ideal for teachers, aides, substitutes, and independent
                  providers. Offers complete access to our training and
                  certification platform on a personal level
                </p>
                <div
                  className={styles.pricingCard}
                  style={{ minHeight: "700px" }}
                >
                  <img
                    src={require("../../assets/img/discount2.jpg")}
                    className={styles.pricingDiscount}
                  ></img>
                  <span>For Schools & Daycares</span>

                  <div className={styles.pricingPrice}>
                    <p className={styles.pricingNum}>$800.00</p>
                    <del className={styles.pricingOriginal}>Was $1000</del>
                    <p className={styles.pricingUnit}>/ Entire staff</p>
                  </div>
                  <div className={styles.pricingList}>
                    <p className={styles.priceDes}>What’s included:</p>
                    <div className={styles.pricingCardText}>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          Full interactive course with scenario-based training
                        </p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>Required testing and printable certification</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>Access for 12 months to refresh as needed</p>
                      </div>
                      <div className={styles.priceOptions}>
                        <img src={CheckImage} />
                        <p>
                          No hidden fees. No upcharges. No extra cost for
                          recertification or new hires.
                        </p>
                      </div>
                    </div>
                    <Link to="/selectregister" className={styles.priceButton}>
                      <button className={styles.pricingBtn}>Sign Up</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className={styles.cta}>
        <h1 className={`text-white ${styles.cta__title}`}>
          Protect your children. Protect your staff. Stay compliant.
        </h1>
        <Link to="/getCertified">
          <button className={styles.cta__button}>
            Get Certified and Protect Your School Now -&gt;
          </button>
        </Link>
      </div>

      <section className={styles.contact__section}>
        <h1 className={styles.contact__heading}>Contact Us</h1>
        <div className={styles.contact}>
          <div>
            <h2 className={styles.contact__title}>
              For more information contact us
            </h2>
            <div>
              <img src={LogoImage} className={styles.contact__logoImg}></img>
            </div>
            <div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/email.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>Edu@AngelWatch.org</p>
              </div>
              <div className={styles.contact__list}>
                <img
                  src={require("../../assets/img/call.png")}
                  className={styles.contact__img}
                ></img>
                <p className={styles.contact__item}>+1 800-381-6794</p>
              </div>
            </div>
          </div>
          <div className={styles.contact__form}>
            <div>
              <p>Your name</p>
              <input
                type="text"
                className={styles.contact__input__info}
                placeholder="John Smith"
                name="name"
                value={formData.name}
                onChange={handleChange}
              ></input>
            </div>
            <div>
              <p>Your email</p>
              <input
                type="email"
                name="email"
                className={styles.contact__input__info}
                placeholder="abc@gmail.com"
                value={formData.email}
                onChange={handleChange}
              ></input>
            </div>
            <div className={styles.contact__message__form}>
              <p>Your message</p>
              <textarea
                type="text"
                name="message"
                className={styles.contact__message__input}
                value={formData.message}
                onChange={handleChange}
              ></textarea>
            </div>
            <button
              style={{ marginBottom: "20px" }}
              onClick={handleSendMessage}
              disabled={!handleCaptchaChange}
            >
              Send Message
            </button>
            <ReCAPTCHA
              sitekey={process.env.REACT_APP_SITE_KEY}
              onChange={handleCaptchaChange}
              className={`${styles.captcha}`}
            />
          </div>
        </div>
      </section>

      {/* Master Skills */}
      {/* /Master Skills */}
      <section className="d-flex flex-column">
        <div className={styles.footerTop}>
          <div className={styles.footerSection}>
            <img className={styles.footerImage} src={logo} />
            <p className={styles.footerDes}>
              All of our techniques, trainings, equipment, software, hardware,
              and instructional materials are classified and proprietary to the
              AngelWatch Foundation. We do not publicly disclose our teaching
              methodologies. This confidentiality is essential to ensure the
              ongoing safety and security of our centers, staff, and the
              children entrusted to our care. By continuously improving,
              adapting, and evolving our systems, we remain one step
              ahead—proactively closing any potential gaps and ensuring every
              base is covered.
            </p>
          </div>

          <div className={styles.footerLoginSection}>
            <p className={styles.footerTitle}>School</p>
            <Link to="/login">
              <a className={styles.footerLink1}>Login</a>
            </Link>
            <Link to="/selectregister">
              <a className={styles.footerLink1}>Register</a>
            </Link>
          </div>

          <div className={styles.footerSection}>
            <p className={styles.footerTitle}>Newsletter</p>
            <input
              className={styles.newsLetter}
              placeholder="Enter your email address"
              type="text"
            />
            <p className={styles.footerLink1}>
              Hampton Reserve Drive, Brentwood tennessee, 37027
            </p>
            <p className={styles.footerLink1}>Edu@AngelWatch.org</p>
            <p className={styles.footerLink1}>+1 800-381-6794</p>
          </div>
        </div>
        <div className={styles.footerBottom}>
          <div className={styles.footerBottomLeft}>
            <p className={styles.footerLink}>Term</p>
            <p className={styles.footerLink}>|</p>
            <p className={styles.footerLink}>Privacy</p>
          </div>
          <div className={styles.footerBottomRight}>
            <p className={styles.footerLink}>
              © 2025 AngelWatch LMS. All rights reserved.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GetCertified;
